import i18next, { use as i18Use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import textFinnish from './locales/fi.json';

export const translations = {
  fi: textFinnish,
};

export default function setup() {
  i18Use(initReactI18next).init({
    lng: 'fi',
    fallbackLng: 'fi',
    resources: {
      ['fi']: {
        translation: translations.fi,
      },
    },
  });

  return i18next;
}
